import Vue from "vue";
import router from "@/router";
import om from "../api";
import * as END_POINTS from "../config/constants/end-points";
import * as ACTIONS from "../config/constants/action-types";
import * as MUTATIONS from "../config/constants/mutation-types";
import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  INDIVIDUO_NEGATIVO_EMPRENDEDOR,
  CLIENTE_EXISTENTE
} from "../config/constants/step-constants";

export default {
  /**
   * Action disparada por el router en
   * cada actualización
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_ROUTE](context, payload) {
    context.commit(MUTATIONS.ON_ROUTE, payload);
    setTimeout(() => {
      // Detener loading al ingresar a ruta nueva
      // Lo hacemos en un timeout = 0 para hacer
      // al final del event loop
      context.commit(MUTATIONS.ON_IS_LOADING, false);
    }, 0);
  },
  [ACTIONS.DO_ROUTE_PUSH](context, ruta) {
    if (ruta !== undefined) {
      router.push(ruta);
    } else {
      context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
    }
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Object} payload
   */
  [ACTIONS.DO_IS_LOADING](context, payload) {
    context.commit(MUTATIONS.ON_IS_LOADING, payload);
  },
  /**
   * Action genérico para llamadas a la API
   * Se debe pasar el endpoint, el action a ejecutar en caso
   * de éxito y el action en caso de error
   * @param {Object} context Vue Context
   * @param {endPoint, payload, doSuccess, doError} actionPayload
   */
  [ACTIONS.DO_REQUEST_API](context, { endPoint, payload, doSuccess, doError }) {
    om.request({ endPoint, body: payload, mock: context.state.mock })
      .then(response => {
        if (doSuccess !== undefined) {
          context.dispatch(doSuccess, response.data);
        }
      })
      .catch(error => {
        if (doError !== undefined) {
          context.dispatch(doError, error);
        } else {
          context.dispatch(ACTIONS.DO_PASO_ERROR, error);
        }
      });
  },
  /**
   * Actions disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} context
   */
  [ACTIONS.DO_PASO1]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);

    payload.esPF = payload.cuit.slice(0, 2) < 30;

    context.commit(MUTATIONS.ON_PASO_1, payload);
    const body = {
      cuit: payload.cuit.split("-").join("")
    };
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.CONSULTA_INDIVIDUO_NEGATIVO,
      doSuccess: ACTIONS.DO_PASO1_SUCCESS,
      payload: body
    });
  },
  [ACTIONS.DO_PASO1_SUCCESS]: (context, payload) => {
    context.commit(MUTATIONS.ON_PASO_1_SUCCESS, payload);

    let isPF = context.getters.getPaso1().esPF;

    if (payload.status === "ERROR") {
      if (payload.respuesta === "ES_NEGATIVO") {
        context.dispatch(
          ACTIONS.DO_MENSAJE,
          isPF === true ? INDIVIDUO_NEGATIVO_EMPRENDEDOR : INDIVIDUO_NEGATIVO
        );
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_ROUTE_PUSH, "paso2");
    }
  },
  [ACTIONS.DO_PASO2]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_PASO_2, payload);
    context.dispatch(ACTIONS.DO_ROUTE_PUSH, "paso3");
  },
  [ACTIONS.DO_PASO3]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_PASO_3, payload);
    context.dispatch(ACTIONS.DO_ROUTE_PUSH, "paso4");
  },
  [ACTIONS.DO_PASO4]: (context, payload) => {
    context.commit(MUTATIONS.ON_IS_LOADING, true);
    context.commit(MUTATIONS.ON_PASO_4, payload);
    let data = context.getters;
    let isPF = data.getPaso1().esPF;
    const body = {
      cuit: data
        .getPaso1()
        .cuit.split("-")
        .join(""),
      razonSocial: data.getPaso1().razonSocial,
      tipoDeActividad: data.getPaso2().tipoActividad,
      rangoFacturacion: data.getPaso2().rangoFacturacion,
      tipoDeCobro: isPF === true ? data.getPaso2().tipoDeCobro : " ",
      lugarDeCobro: isPF === true ? data.getPaso2().lugarDeCobro : " ",
      volumenDeOperaciones:
        isPF === true ? data.getPaso2().volumenDeOperaciones : " ",
      nombre: data.getPaso3().nombre,
      apellido: data.getPaso3().apellido,
      telefono: data.getPaso3().phone.area + data.getPaso3().phone.numero,
      email: data.getPaso3().email,
      sucursal: ("0000" + data.getPaso4().numSucursal).slice(-4),
      cargo: data.getPaso3().cargoArea,
      horarioContacto: data.getPaso3().horario,
      lineasDeFinanciacion: data.getPaso4().financiacion,
      cobrosYPagos: !isPF === true ? data.getPaso4().cobrosPagos : false, // Si es PF no se muestra el campo cobrosYPagos
      seguroComercio: isPF === true ? data.getPaso4().seguroComercio : false, // Si no es PF no se muestra el campo seguroComercio
      origen: data.getOrigen(),
      esEmprendedor: data.getPaso1().esPF,
      dirSucursal: data.getPaso4().dirSucursal
    };
    context.dispatch(ACTIONS.DO_REQUEST_API, {
      endPoint: END_POINTS.GUARDAR_DATOS_CONTACTO,
      doSuccess: ACTIONS.DO_PASO4_SUCCESS,
      payload: body
    });
  },
  [ACTIONS.DO_PASO4_SUCCESS]: (context, payload) => {
    if (payload.status === "ERROR") {
      if (payload.respuesta === "CLIENTE_EXISTENTE") {
        let isPF = context.getters.getPaso1().esPF;
        context.dispatch(
          ACTIONS.DO_MENSAJE,
          isPF === true ? INDIVIDUO_NEGATIVO_EMPRENDEDOR : CLIENTE_EXISTENTE
        );
      } else {
        context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
      }
    } else {
      context.dispatch(ACTIONS.DO_ROUTE_PUSH, "gracias");
    }
  },
  [ACTIONS.DO_PASO_ERROR]: (context, payload) => {
    Vue.$log.error(payload);
    context.dispatch(ACTIONS.DO_MENSAJE, ERROR_TECNICO);
  },
  /**
   * Mostrar un mensaje de error
   * @param {Object} context
   * @param {Object} payload Código del mensaje
   */
  [ACTIONS.DO_MENSAJE]: (context, payload) => {
    router.push({
      name: "mensaje",
      params: {
        mje: payload || ERROR_TECNICO
      }
    });
  },
  [ACTIONS.DO_CLICK_TRACKING]: (context, payload) => {
    // El evento de click solo debe trackearse con el primer elemento
    // que interactúa
    if (context.state.trackClickElement === null) {
      context.commit(MUTATIONS.ADOBE_APP_STARTED, payload);
    }
  },
  [ACTIONS.DO_MOCK]: (context, payload) => {
    context.commit(MUTATIONS.ON_MOCK, payload);
  },
  /**
   * Action para mostrar notificaciones en el front
   * en modo "toast"
   * @param {Object} context
   * @param {Object} payload: {type: String ["info", "success", "alert"], message: String}
   */
  [ACTIONS.DO_NOTIFICATION_TOAST](context, payload) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, payload);
    setTimeout(() => {
      // Luego de 3 segundos quitamos la notificacion
      context.dispatch(ACTIONS.DO_NOTIFICATION_TOAST_RESET);
    }, 3000);
  },
  [ACTIONS.DO_NOTIFICATION_TOAST_RESET](context) {
    context.commit(MUTATIONS.ON_NOTIFICATION_TOAST, {
      type: "",
      message: ""
    });
  }
};
